import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as S from "./LoadingWrapper.styled";
export var LoadingWrapper = function (props) {
    var isLoading = props.isLoading, children = props.children;
    return (_jsxs(S.Wrapper, { children: [_jsx(S.Content, { isLoading: isLoading, children: children }), isLoading && (_jsx(S.LoaderContainer, { children: _jsx(S.Loader, { children: _jsx(S.Dots, { asDots: true }) }) }))] }));
};
